import { AxiosRequestConfig } from "axios";
import baseApi, { version1 } from "../../Libs/Config/APIConfig";
import { CreatePayerPayload } from "../../Libs/Types/API-Payloads";

interface CustomAxiosRequestConfig<T = unknown> extends AxiosRequestConfig<T> {}
const BaseDataConfig: CustomAxiosRequestConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const apiGetPayerList = async () => {
  return baseApi.get(`/api/${version1}/payers/`, BaseDataConfig);
};

export const apiGetPayerById = async (payload: string) => {
  return baseApi.get(`/api/${version1}/payers/${payload}`, BaseDataConfig);
};

export const apiAddPayer = async (payload: CreatePayerPayload) => {
  return baseApi.post(`/api/${version1}/payers/`, payload, BaseDataConfig);
};

export const apiDeletePayer = async (query: string) => {
  return baseApi.delete(`/api/${version1}/payers/${query}`, BaseDataConfig);
};

export const apiUpdatePayer = async ({
  payload,
  id,
}: {
  payload: CreatePayerPayload;
  id: string;
}) => {
  return baseApi.patch(
    `/api/${version1}/payers/${id}`,
    payload,
    BaseDataConfig
  );
};
